module.exports = __webpack_public_path__ + "static/media/window.8da79196.svg";